var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZalll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2873_701618)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 30.0605,
    r: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4737 41.3688V13.7312L24.3264 12.9629C19.4484 14.9211 16 19.6854 16 25.2635V34.7372C16 42.0623 21.9381 48.0004 29.2632 48.0004H38.7368C43.2103 48.0004 47.1523 45.7759 49.553 42.3815V41.3688H25.4737Z",
    fill: "#037CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7365 12H29.2629C27.515 12 25.8514 12.3467 24.3233 12.9606C21.1657 16.0263 18.8418 21.0265 18.8418 25.2632C18.8418 31.6778 19.7285 35.4332 22.3584 39.1014C22.5631 39.3865 22.6966 39.72 22.7146 40.0696C22.7554 40.8606 22.5924 42.3101 21.1666 43.6146C21.0132 43.7548 21.1107 44.0116 21.3182 44.0201C22.2106 44.059 24.0116 44.0069 25.8627 43.1893C26.3904 42.9562 26.9911 42.997 27.5007 43.2679C30.6394 44.9343 34.3152 45.1579 37.7892 45.1579C42.2191 45.1579 46.6366 44.1726 49.5526 42.3954C51.0883 40.2306 51.9997 37.5922 51.9997 34.7368V25.2632C51.9997 17.9381 46.0616 12 38.7365 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.078 32.8435C44.1198 32.8435 42.5254 31.2491 42.5254 29.2909C42.5254 27.3327 44.1198 25.7383 46.078 25.7383C48.0362 25.7383 49.6307 27.3327 49.6307 29.2909C49.6307 31.2491 48.0362 32.8435 46.078 32.8435ZM46.078 27.1593C44.9033 27.1593 43.9464 28.1162 43.9464 29.2909C43.9464 30.4657 44.9033 31.4225 46.078 31.4225C47.2528 31.4225 48.2096 30.4657 48.2096 29.2909C48.2096 28.1162 47.2528 27.1593 46.078 27.1593Z",
    fill: "#037CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1046 32.8427H40.1573C39.8958 32.8427 39.6836 32.6305 39.6836 32.369V24.3164H41.1046V32.8427Z",
    fill: "#037CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8424 25.9751V26.4668C36.2465 26.0159 35.5133 25.7383 34.7108 25.7383C32.7526 25.7383 31.1582 27.3327 31.1582 29.2909C31.1582 31.2491 32.7526 32.8435 34.7108 32.8435C35.5133 32.8435 36.2465 32.566 36.8424 32.115V32.3699C36.8424 32.6313 37.0546 32.8435 37.3161 32.8435H38.2635V25.9751H36.8424ZM34.7108 31.4225C33.5361 31.4225 32.5793 30.4657 32.5793 29.2909C32.5793 28.1162 33.5361 27.1593 34.7108 27.1593C35.8856 27.1593 36.8424 28.1162 36.8424 29.2909C36.8424 30.4657 35.8856 31.4225 34.7108 31.4225Z",
    fill: "#037CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3944 24.3164H23.8155V25.7375H28.8564L23.5786 31.8954H23.6033C23.4488 32.0953 23.3418 32.334 23.3418 32.6059V32.8427H30.4471C30.7085 32.8427 30.9207 32.6305 30.9207 32.369V31.4217H25.8798L31.1576 25.2638H31.133C31.2874 25.0639 31.3944 24.8251 31.3944 24.5532V24.3164Z",
    fill: "#037CCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2873_701618",
    x: 0,
    y: 0,
    width: 68,
    height: 68.0605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2873_701618"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2873_701618",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZalll);
export default __webpack_public_path__ + "static/media/zalll.37684f2ff9187391e33c6caf39b1f51c.svg";
export { ForwardRef as ReactComponent };